var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-fail",style:({'--top-safety-height': _vm.topSafetyHeightCss})},[_c('van-image',{attrs:{"src":_vm.base64Data,"width":"180","height":"180"}}),_c('div',{staticClass:"tips"},[_vm._v("网络不太给力，请点击重新加载")]),_c('div',{staticClass:"reload",on:{"click":_vm.reloadFn}},[_vm._v("重新加载")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }